<template>
  <div class="partners-page">
    <p class="section-subtitle">Why Our Channel Partner Network Matters ?</p>
    <h2 class="section-title">Our Channel Partners</h2>
    <div class="underline"></div>

    <div class="features-row">
      <div v-for="(item, index) in features" :key="index" class="feature-box">
        <div class="feature-icon">
          <!-- ✅ Use <img> for SVG instead of <i> -->
          <img :src="item.image" alt="" />
        </div>
        <h2 class="feature-title">{{ item.title }}</h2>
        <p class="feature-desc">{{ item.description }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChannelPartners",
  data() {
    return {
      features: [
        {
          title: "Regional Reach",
          description: "Offer on-ground support in local languages, tailored to your area.",
          image: require("@/assets/icons/Regional_reach.svg")
        },
        {
          title: "Quick Response",
          description: "Faster installation, service, and real-time troubleshooting.",
          image: require("@/assets/icons/Quick_response.svg")
        },
        {
          title: "Hands-On Training",
          description: "Personalized onboarding and guidance for smooth adoption.",
          image: require("@/assets/icons/Hands-on_training.svg")
        },
        {
          title: "Long-Term Collaboration",
          description: "Trusted partnerships for long-term growth.",
          image: require("@/assets/icons/Long_term_collab.svg")
        },
        {
          title: "Cultural Fit",
          description: "Regional knowledge for smoother communication.",
          image: require("@/assets/icons/cultural_fit.svg")
        },
        {
          title: "Responsibility & Profit Sharing",
          description:
            "We work hand in hand with our channel partners and share a portion of the profits with you.",
          image: require("@/assets/icons/Responsibility_and_profit_sharing.svg")
        }
      ]
    };
  }
};
</script>

<style scoped>
.partners-page {
  padding: 60px 40px;
  text-align: center;
  background: #fff;
}

.section-subtitle {
  font-size: 1.2rem;
  font-weight: 500;
  margin-bottom: 10px;
  color: #444;
}

.section-title {
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 50px;
  color: #206A98;
}

.underline {
  width: 10%;
  height: 3px;
  background: #206A98;
  margin: 0 auto 40px;
  border-radius: 2px;
}

.features-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 40px 60px;
  max-width: 1200px;
  margin: 0 auto;
}

.feature-box {
  max-width: 100%;
  text-align: center;
  padding: 10px;
}

.feature-icon {
  background: #206A98;
  width: 70px;
  height: 70px;
  border-radius: 50%;
  margin: 0 auto 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.feature-icon img {
  width: 50px;  /* control icon size */
  height: 50px;
  object-fit: contain;
  filter: brightness(0) invert(1); /* makes svg white if it has fill colors */
  margin-bottom: 0px;
}

.feature-title {
  font-size: 1.1rem;
  font-weight: bold;
  margin-bottom: 10px;
  color: #333;
}

.feature-desc {
  font-size: 0.95rem;
  color: #666;
  line-height: 1.5;
  max-width: 280px;
  margin: 0 auto;
}

/* Tablet View */
@media (max-width: 1023px) {
  .features-row {
    grid-template-columns: repeat(2, 1fr);
    gap: 30px 40px;
  }
}

/* Mobile View */
@media (max-width: 768px) {
  .features-row {
    grid-template-columns: 1fr;
    gap: 25px;
  }

  .feature-box {
    width: 100%;
    max-width: 350px;
    margin: 0 auto;
  }

  .section-title {
    font-size: 22px;
  }
}
</style>

